<template>
  <div class="ProductPrices">
    <template v-if="basePriceMin < basePriceMax">
      <div class="ProductPrices__main">
        <span class="ProductPrices__from">From</span>
        <ShopifyPrice unit="dollars" :amount="basePriceMin" />
        <template v-if="showUpperRange">
          <span class="ProductPrices__dash">—</span>
          <ShopifyPrice unit="dollars" :amount="basePriceMax" />
        </template>
      </div>

      <span v-if="showChainSuffix" class="ProductPrices__suffix">(+ Chain)</span>
    </template>

    <template v-else>
      <div class="ProductPrices__main">
        <ShopifyPrice unit="dollars" :amount="basePriceMin" />
      </div>

      <span v-if="showChainSuffix" class="ProductPrices__suffix">(+ Chain)</span>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed, withDefaults } from 'vue'
import { useProductInject } from '../../context/useProductContext'
import ShopifyPrice from '../shopify/ShopifyPrice.vue'

const { product } = useProductInject()

const props = withDefaults(
  defineProps<{
    available?: boolean
    showUpperRange?: boolean
  }>(),
  {
    available: true,
    showUpperRange: true,
  }
)

// Base product range only (does not include chain pricing)
const basePriceMin = computed(() => Number(product.priceRange?.minVariantPrice?.amount || 0))
const basePriceMax = computed(() => Number(product.priceRange?.maxVariantPrice?.amount || 0))

const showChainSuffix = computed(() => Boolean(product.chainEnabled?.value))
</script>

<style lang="scss">
@import '~styles/base';

.ProductPrices {
  display: flex;
  flex-direction: column; /* forces (+ Chain) to next line */

  &__main {
    display: flex;
    align-items: baseline;

    @include breakpoint('l') {
      justify-content: flex-end;
    }
  }

  &__suffix {
    white-space: nowrap;
  }

  &__from {
    margin-right: 4px;
  }

  &__dash {
    margin: 0 4px;
  }
}
</style>
